import WebViewTitleDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/webViewTitleDesc.mdx";
import CaptureBillingAddressEnabledDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/captureBillingAddressEnabledDesc.mdx";
import ApplePayUnsupportedDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/applePayUnsupportedDesc.mdx";
import CheckProvidedNetworksDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/checkProvidedNetworksDesc.mdx";
import CardPaymentOptionsDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/cardPaymentOptionsDesc.mdx";
import AllowedCardNetworksDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/allowedCardNetworksDesc.mdx";
import ExistingMethodRequiredDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/existingMethodRequiredDesc.mdx";
import IOSThreeDsDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/iOSThreeDsDesc.mdx";
import AndroidThreeDsDesc from "../../../../content/sdk/react-native/2.x.x/common/settings/androidThreeDsDesc.mdx";
import * as React from 'react';
export default {
  WebViewTitleDesc,
  CaptureBillingAddressEnabledDesc,
  ApplePayUnsupportedDesc,
  CheckProvidedNetworksDesc,
  CardPaymentOptionsDesc,
  AllowedCardNetworksDesc,
  ExistingMethodRequiredDesc,
  IOSThreeDsDesc,
  AndroidThreeDsDesc,
  React
};